var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                attrs: {
                  required: "",
                  rules: [{ required: true, message: "请输入姓名" }],
                  name: "userName",
                  maxlength: "50",
                  autosize: "",
                  label: "姓名",
                  placeholder: "请输入姓名",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userName,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userName", $$v)
                  },
                  expression: "formData.userName",
                },
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "userSex",
                  value: _vm.formData.userSex,
                  label: "性别",
                  required: "",
                  rules: [{ required: true, message: "请选择性别" }],
                  placeholder: "请选择性别",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.userSex,
                            placeholder: "请选择性别",
                            options: {
                              data: _vm.userSex.data,
                              showFields: "dictLabel",
                              valueKey: "dictValue",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.userSex.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.userSex.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.userSex, "show", $$v)
                              },
                              expression: "userSex.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择性别",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.userSex.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("userSex", {
                                    value: "dictValue",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.userSex,
                                    "dictLabel"
                                  )
                                },
                              },
                              model: {
                                value: _vm.userSex.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userSex, "filterText", $$v)
                                },
                                expression: "userSex.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "userSex",
                              attrs: {
                                "value-key": "dictLabel",
                                columns: _vm.userSex.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.userSex.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  type: "number",
                  name: "userAge",
                  maxlength: "50",
                  autosize: "",
                  label: "年龄",
                  placeholder: "请输入年龄",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userAge,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userAge", $$v)
                  },
                  expression: "formData.userAge",
                },
              }),
              _c("van-field", {
                attrs: {
                  type: "number",
                  name: "userTelephone",
                  maxlength: "50",
                  autosize: "",
                  label: "手机号",
                  placeholder: "请输入手机号",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userTelephone,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userTelephone", $$v)
                  },
                  expression: "formData.userTelephone",
                },
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "companyId",
                  value: _vm.formData.companyId,
                  label: "所属客户",
                  placeholder: "请选择所属客户",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            isShowIcon: false,
                            value: _vm.formData.companyId,
                            placeholder: "请选择所属客户",
                            options: {
                              data: _vm.companyId.data,
                              showFields: "companyName",
                              valueKey: "id",
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  required: "",
                  rules: [{ required: true, message: "请输入所属部门" }],
                  name: "userDeptName",
                  maxlength: "50",
                  autosize: "",
                  label:
                    _vm.formData.industryType == "0" ? "所属部门" : "所在学院",
                  placeholder: `请输入${
                    _vm.formData.industryType == "0" ? "所属部门" : "所在学院"
                  }`,
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userDeptName,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userDeptName", $$v)
                  },
                  expression: "formData.userDeptName",
                },
              }),
              _vm.formData.industryType != "0"
                ? _c("van-field", {
                    attrs: {
                      name: "userXi",
                      maxlength: "50",
                      autosize: "",
                      label: "所在系",
                      placeholder: "请输入所在系",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.userXi,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "userXi", $$v)
                      },
                      expression: "formData.userXi",
                    },
                  })
                : _vm._e(),
              _c("van-field", {
                attrs: {
                  name: "userPost",
                  maxlength: "50",
                  autosize: "",
                  label: "职务",
                  placeholder: "请输入职务",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userPost,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userPost", $$v)
                  },
                  expression: "formData.userPost",
                },
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "roleNature",
                  value: _vm.formData.roleNature,
                  label: "角色性质",
                  placeholder: "请选择角色性质",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.roleNature,
                            placeholder: "请选择角色性质",
                            options: {
                              data: _vm.roleNature.data,
                              showFields: "dictLabel",
                              valueKey: "dictValue",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.roleNature.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.roleNature.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.roleNature, "show", $$v)
                              },
                              expression: "roleNature.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择角色性质",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.roleNature.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("roleNature", {
                                    value: "dictValue",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.roleNature,
                                    "dictLabel"
                                  )
                                },
                              },
                              model: {
                                value: _vm.roleNature.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.roleNature, "filterText", $$v)
                                },
                                expression: "roleNature.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "roleNature",
                              attrs: {
                                "value-key": "dictLabel",
                                columns: _vm.roleNature.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.roleNature.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  name: "firstContact",
                  label: "初次接触客户时间",
                  placeholder: "初次接触客户时间",
                  "input-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.firstContact,
                            placeholder: "请选择初次接触客户时间",
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.firstContact.show = true
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "firstContact",
                          attrs: {
                            "min-date": _vm.firstContact.minDate,
                            "show-confirm": false,
                            title: "选择初次接触客户时间",
                          },
                          on: { confirm: _vm.firstContactConfirm },
                          model: {
                            value: _vm.firstContact.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.firstContact, "show", $$v)
                            },
                            expression: "firstContact.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.firstContact,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "firstContact", $$v)
                  },
                  expression: "formData.firstContact",
                },
              }),
              _c("van-field", {
                attrs: {
                  name: "userWorkPlace",
                  maxlength: "50",
                  autosize: "",
                  label: "工作地点/房间号",
                  placeholder: "请输入工作地点/房间号",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userWorkPlace,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userWorkPlace", $$v)
                  },
                  expression: "formData.userWorkPlace",
                },
              }),
              _c("van-field", {
                attrs: {
                  name: "userLeader",
                  maxlength: "50",
                  autosize: "",
                  label: "直属领导",
                  placeholder: "请输入直属领导",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userLeader,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userLeader", $$v)
                  },
                  expression: "formData.userLeader",
                },
              }),
              _c("van-field", {
                attrs: {
                  type: "number",
                  name: "userMobile",
                  maxlength: "50",
                  autosize: "",
                  label: "固定电话",
                  placeholder: "请输入固定电话",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userMobile,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userMobile", $$v)
                  },
                  expression: "formData.userMobile",
                },
              }),
              _c("van-field", {
                attrs: {
                  name: "userEmail",
                  maxlength: "50",
                  autosize: "",
                  label: "邮箱",
                  placeholder: "请输入邮箱",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userEmail,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userEmail", $$v)
                  },
                  expression: "formData.userEmail",
                },
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "userEmpnasis",
                  value: _vm.formData.userEmpnasis,
                  label: "是否重点维护",
                  required: "",
                  rules: [{ required: true, message: "请选择是否重点维护" }],
                  placeholder: "请选择是否重点维护",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.userEmpnasis,
                            placeholder: "请选择是否重点维护",
                            options: {
                              data: _vm.userEmpnasis.data,
                              showFields: "dictLabel",
                              valueKey: "dictValue",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.userEmpnasis.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.userEmpnasis.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.userEmpnasis, "show", $$v)
                              },
                              expression: "userEmpnasis.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择是否重点维护",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.userEmpnasis.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("userEmpnasis", {
                                    value: "dictValue",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.userEmpnasis,
                                    "dictLabel"
                                  )
                                },
                              },
                              model: {
                                value: _vm.userEmpnasis.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userEmpnasis, "filterText", $$v)
                                },
                                expression: "userEmpnasis.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "userEmpnasis",
                              attrs: {
                                "value-key": "dictLabel",
                                columns: _vm.userEmpnasis.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.userEmpnasis.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "userMain",
                  value: _vm.formData.userMain,
                  label: "是否关键联系人",
                  placeholder: "请选择是否关键联系人",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.userMain,
                            placeholder: "请选择是否关键联系人",
                            options: {
                              data: _vm.userMain.data,
                              showFields: "dictLabel",
                              valueKey: "dictValue",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.userMain.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.userMain.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.userMain, "show", $$v)
                              },
                              expression: "userMain.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择是否关键联系人",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.userMain.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("userMain", {
                                    value: "dictValue",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.userMain,
                                    "dictLabel"
                                  )
                                },
                              },
                              model: {
                                value: _vm.userMain.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userMain, "filterText", $$v)
                                },
                                expression: "userMain.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "userMain",
                              attrs: {
                                "value-key": "dictLabel",
                                columns: _vm.userMain.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.userMain.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  name: "userFamilyAddress",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "家庭住址",
                  placeholder: "请输入家庭住址",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userFamilyAddress,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userFamilyAddress", $$v)
                  },
                  expression: "formData.userFamilyAddress",
                },
              }),
              _c("van-field", {
                attrs: {
                  name: "userLike",
                  maxlength: "50",
                  autosize: "",
                  label: "爱好",
                  placeholder: "请输入爱好",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userLike,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userLike", $$v)
                  },
                  expression: "formData.userLike",
                },
              }),
              _c("van-field", {
                attrs: {
                  name: "userStrongPoint",
                  maxlength: "50",
                  autosize: "",
                  label: "特长",
                  placeholder: "请输入特长",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userStrongPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userStrongPoint", $$v)
                  },
                  expression: "formData.userStrongPoint",
                },
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "companyProvince",
                  value: _vm.formData.companyProvince,
                  label: "所属部门",
                  placeholder: "请选择所属部门",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            isShowIcon: false,
                            value: _vm.formData.deptId,
                            placeholder: "请选择所属部门",
                            options: {
                              data: _vm.jurisdictionDeptTree,
                              showFields: "label",
                              valueKey: "value",
                              childrenKey: "children",
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  name: "userBusiness",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "业务范围",
                  "show-word-limit": "",
                  placeholder: "请输入业务范围",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.userBusiness,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "userBusiness", $$v)
                  },
                  expression: "formData.userBusiness",
                },
              }),
              _c("van-field", {
                attrs: {
                  name: "remark",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "备注",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "remark", $$v)
                  },
                  expression: "formData.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "bottom-bar-placeholder" }, [
        _c("div", { staticClass: "bottom-bar flex" }, [
          _c(
            "div",
            {
              staticClass: "btn-item flex-1 bg-FFDB43",
              on: {
                click: function ($event) {
                  return _vm.submit(0)
                },
              },
            },
            [_vm._v(" " + _vm._s("确定") + " ")]
          ),
          !_vm.customerId
            ? _c(
                "div",
                {
                  staticClass: "btn-item flex-2 bg-FFDB43",
                  on: {
                    click: function ($event) {
                      return _vm.submit(1)
                    },
                  },
                },
                [_vm._v(" " + _vm._s("保存并录入下一条") + " ")]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "btn-item flex-1 bg-FF", on: { click: _vm.goBack } },
            [_vm._v(" " + _vm._s("返回") + " ")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }